import type { StepView } from '~/helpers/learner/session-view'
import { CalendarClock, Lock } from 'lucide-react'
import { DATE_WITH_YEAR } from '~/helpers/dates/session-dates'
import { useLockReason } from '~/pages/scorm/components/useLockReason'

/**
 * Pourquoi une étape est fermée, avec son icône : un calendrier pour une date à
 * attendre, un cadenas pour un module ou un score à obtenir (#80).
 */
function LockNotice({ step, steps }: { step: StepView, steps: StepView[] }) {
  const lockReason = useLockReason(DATE_WITH_YEAR)
  const Icon = step.lockReason === 'SCHEDULED' ? CalendarClock : Lock

  return (
    <p className="flex items-start gap-2 text-sm text-muted-foreground">
      <Icon className="mt-0.5 size-4 shrink-0" />
      <span className="min-w-0">{lockReason(step, steps)}</span>
    </p>
  )
}

export default LockNotice
